import { SearchUsersParams, SearchUsersResponse } from '../components/sendbird/supportPage';
import { axiosRequestData } from '../helpers/axios';

export const searchUsers = async (params: SearchUsersParams): Promise<SearchUsersResponse> => {
    const res = await axiosRequestData('POST', '/wp-json/pg/v1/vip/search_users', params);
    return res.data as SearchUsersResponse;
};

export const getSendbirdChannel = async (userId: number, supportUserId: number): Promise<{ channel_url: string, support_access_token: string, support_user_sendbird_id: string } | null> => {
    try {
        const res = await axiosRequestData('POST', '/wp-json/pg/v1/vip/get_sendbird_support_channel', { user_id: userId, support_user_id: supportUserId });
        return res.data as { channel_url: string, support_access_token: string, support_user_sendbird_id: string };
    } catch {
        return null;
    }
};
